export function register(config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          if (registration.waiting && config?.onUpdate) {
            config.onUpdate(registration);
          }

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;

            installingWorker.onstatechange = () => {
              if (
                installingWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                config?.onUpdate?.(registration);
              }
            };
          };
        })
        .catch((err) => {
          console.error('SW registration failed:', err);
        });
    });
  }
}
